export default function Logo() {
  return (
    <img
      src="/logo_image.png"
      alt="西日本ファクタープラス"
      style={{ height: '40px', objectFit: 'contain' }}
    />
  );
}
